import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';
import {
  faEnvelope,
  faCalendarAlt,
  faHeart,
  faBookmark,
} from '@fortawesome/free-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Question from '../../../components/Help/Questions/Question';

class HelpForShadowersSection extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Panel>
          <Panel.Heading>Shadowing Basics</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  There are two main types of shadowing sessions:
                  observation-only and interactive.
                  <ul>
                    <li>
                      Observation-only:
                      <p>
                        During observation-only sessions, shadowers will mostly
                        follow the expert, take notes, ask questions and receive
                        feedback.
                      </p>
                    </li>
                    <li>
                      Interactive:
                      <p>
                        During interactive sessions, experts will provide
                        hands-on training, allowing shadowers to operate
                        equipment, tools and software, as well as provide
                        feedback on personal projects. Typically interactive
                        sessions costs more.
                      </p>
                    </li>
                  </ul>
                </div>
              }
              question="What is a typical shadowing session like?"
            />

            <Question
              answer={
                <div>
                  Experts set the length of the session, but most last about 1
                  to 2 hours.
                </div>
              }
              question="How long are the sessions?"
            />

            <Question
              answer={
                <div>
                  The sessions take place at the expert’s place of work,
                  personal office or home studio. Experts can also choose to
                  provide sessions at the home of the shadower as well for an
                  additional fee.
                </div>
              }
              question="Where do the sessions take place?"
            />

            <Question
              answer={
                <div>
                  The expert determines the number of shadowers allowed per
                  session, but most sessions are one-on-one.
                </div>
              }
              question="How many shadowers are allowed per session?"
            />

            <Question
              answer={
                <div>
                  One-on-one sessions are private, but all sessions that allow
                  two or more shadowers are automatically open to the public.
                </div>
              }
              question="Are the sessions public or private?"
            />

            <Question
              answer={
                <div>
                  Experts determine what they want to provide. Typically,
                  shadowers will have access to the tools and equipment of the
                  expert. Some may also provide supplemental educational
                  material, a take-home project and snacks or beverages.
                </div>
              }
              question="What will be provided?"
            />

            <Question
              answer={
                <div>
                  Minors under the age of 13 are not allowed to use Shadower's
                  services and we request that they do not provide personal
                  information on the platform. Experts can set their own
                  personal age restrictions as well.
                </div>
              }
              question="Are there age restrictions?"
            />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>About the Experts</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  Usually, the expert will be operating their tools, technology
                  and software and performing their work duties in a real-world
                  environment. If the session is more interactive, shadowers may
                  assist the expert in their duties, work on a project under the
                  supervision of the expert or receive feedback and help with
                  their own personal projects.
                </div>
              }
              question="What will experts specifically be doing?"
            />

            <Question
              answer={
                <div>
                  You will be able to score your expert and provide a review
                  after every shadowing session. Experts with a low score for an
                  extended period of time will not be allowed to let others
                  shadow them.
                </div>
              }
              question="How do shadowers know an expert is qualified?"
            />

            <Question
              answer={
                <div>
                  You can message your expert by navigating to their shadowing
                  profile and clicking on{' '}
                  <strong>
                    <FontAwesomeIcon icon={faEnvelope} />
                    &nbsp; Contact
                  </strong>{' '}
                  under their profile photo. All messages will be available in
                  your{' '}
                  <strong>
                    <FontAwesomeIcon icon={faEnvelope} />
                    &nbsp; Inbox
                  </strong>
                  .
                </div>
              }
              question="How do I message my expert?"
            />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>Using the Platform</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  <div>Saving (Coming in a future release):</div>
                  Individual sessions can be saved for your future reference and
                  are accessible through your <strong>
                    Dashboard
                  </strong> under{' '}
                  <strong>
                    <FontAwesomeIcon icon={faBookmark} />
                    &nbsp; Saved Sessions
                  </strong>
                  . Saved sessions are automatically removed from your list
                  after the session has passed.
                  <br />
                  <br />
                  To save a session:
                  <ul>
                    <li>
                      Find a session of interest and click on the bookmark icon{' '}
                      <strong>
                        <FontAwesomeIcon icon={faBookmark} />
                      </strong>{' '}
                      below the description.
                    </li>
                  </ul>
                  To remove a saved a session:
                  <ul>
                    <li>
                      Navigate to{' '}
                      <strong>
                        <FontAwesomeIcon icon={faBookmark} />
                        &nbsp; Saved Sessions
                      </strong>
                      and click on the session's bookmark icon{' '}
                      <strong>
                        {' '}
                        <FontAwesomeIcon icon={faBookmark} />
                      </strong>
                      .
                    </li>
                  </ul>
                  <br />
                  <div>Favoriting:</div>
                  Shadowing profiles can be favorited and are accessible through
                  your <strong>Dashboard</strong> under{' '}
                  <strong>
                    <FontAwesomeIcon icon={faHeart} />
                    &nbsp; Favorites
                  </strong>
                  . You will receive a notification when new sessions are added
                  by an expert whose profile you have favorited (coming in a
                  future release).
                  <br />
                  <br />
                  To favorite a profile:
                  <ul>
                    <li>
                      Click on the profile or category's heart icon{' '}
                      <strong>
                        <FontAwesomeIcon icon={faHeart} />
                      </strong>
                      .
                    </li>
                  </ul>
                  To remove a favorited profile:
                  <ul>
                    <li>
                      Navigate to{' '}
                      <strong>
                        <FontAwesomeIcon icon={faHeart} />
                        &nbsp; Favorites
                      </strong>
                      and click on the heart icon{' '}
                      <strong>
                        <FontAwesomeIcon icon={faHeart} />
                      </strong>{' '}
                      of the profile.
                    </li>
                  </ul>
                  {/*  To hide a favorited profile or category from
                public view:
                <ul>
                  <li>
                    Navigate to <strong>  <FontAwesomeIcon icon={faHeart} />
                      &nbsp; Favorites</strong>
                    and select <strong>Hide</strong>.
                  </li>
                </ul> */}
                </div>
              }
              question="Saving versus favoriting"
            />

            <Question
              answer={
                <div>
                  Click on your <strong>Calendar</strong> and navigate to{' '}
                  <strong>
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    &nbsp; Shadowing Others
                  </strong>{' '}
                  to view all of the upcoming sessions that you have booked.
                  {/*  At the bottom, you can click on{' '}
                <strong>Previous Sessions</strong> to view all of
                the sessions you have attended in the past. */}
                </div>
              }
              question="How do I view my sessions booked with others?"
            />
          </Panel.Body>
        </Panel>
        <Panel>
          <Panel.Heading>Payment</Panel.Heading>
          <Panel.Body>
            <Question
              answer={
                <div>
                  Every expert sets their own price, which varies depending on
                  the shadowing session’s level of interactivity. The average
                  shadowing session is about $40 for an hour.
                </div>
              }
              question="How much does it cost to shadow an expert?"
            />

            <Question
              answer={
                <div>
                  All payments are processed safely and securely through
                  Braintree and PayPal.
                </div>
              }
              question="How are payments handled?"
            />

            {/* <Question
            question="Are there any extra fees to shadow?"
            answer={
              <div>
                A booking fee of 10 percent will be automatically
                added to the price of the session.
              </div>
            }
          /> */}

            <Question
              answer={
                <div>
                  Shadowers have 24 hours to cancel their shadowing session for
                  a full refund. Sessions booked within 24 hours of the
                  scheduled start time are non-refundable. All sessions canceled
                  by experts are fully refundable.
                </div>
              }
              question="What is the cancellation policy?"
            />

            {/*  <Question
            question="How do I view my billing history?"
            answer={
              <div>
                In the{' '}
                <strong>
                  <FontAwesomeIcon icon={faCreditCard} />
                  &nbsp; Payment
                </strong>{' '}
                page of your{' '}
                <strong>
                  <FontAwesomeIcon icon={faCreditCard} />
                  &nbsp; Account
                </strong>
                , you will find a button labeled{' '}
                <strong>Billing History</strong>.
              </div>
            }
          /> */}
          </Panel.Body>
        </Panel>
      </React.Fragment>
    );
  }
}

export default HelpForShadowersSection;
